module.exports = __webpack_public_path__ + "static/technology-infographic-877245c34073a074ad72612c0c3b5ee4.jpg";